import React, {useState, useEffect} from 'react';
import styles from "../../../assets/styles/modules/Newsinfo.module.css";


const NewsKeywordCard = ({news, keywords,keywordBtnClick, setKeywordNewsList}) => {

    const [btnIdx, setBtnIdx] = useState(0)
    useEffect(()=> keywordBtnClick(0), [keywords])

    return (
        <div className={styles.keyword_container}>
            <p className='title_md'>{news.subject} 관련 키워드</p>
            <div className={styles.btn_container}>
                    {keywords && keywords.map((keyword, idx) =>
                            <button key={idx}
                                    className={`${styles.keyword_btn} ${btnIdx === idx}`}
                                    onClick={() => {
                                        setBtnIdx(idx)
                                        setKeywordNewsList(keywords[idx].newslist)
                                        keywordBtnClick(idx)
                                    }}>
                                {keyword.keyword}
                            </button>
                    )}
            </div>
        </div>
    );
};

export default NewsKeywordCard;